"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = collectionsRootSaga;
exports.fetchAllCollectionsByTypesSaga = fetchAllCollectionsByTypesSaga;
var _effects = require("redux-saga/effects");
var R = _interopRequireWildcard(require("ramda"));
var _actions = require("../../../bus/ui/actions");
var _selectors = require("../../../bus/auth/selectors");
var _localization = require("../../../localization");
var _api = require("../../../helpers/api");
var _constants = require("./constants");
var _helpers = require("./helpers");
var _actions2 = require("./actions");
var _selectors2 = require("./selectors");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return r; }; var t, r = {}, e = Object.prototype, n = e.hasOwnProperty, o = "function" == typeof Symbol ? Symbol : {}, i = o.iterator || "@@iterator", a = o.asyncIterator || "@@asyncIterator", u = o.toStringTag || "@@toStringTag"; function c(t, r, e, n) { return Object.defineProperty(t, r, { value: e, enumerable: !n, configurable: !n, writable: !n }); } try { c({}, ""); } catch (t) { c = function c(t, r, e) { return t[r] = e; }; } function h(r, e, n, o) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype); return c(a, "_invoke", function (r, e, n) { var o = 1; return function (i, a) { if (3 === o) throw Error("Generator is already running"); if (4 === o) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var u = n.delegate; if (u) { var c = d(u, n); if (c) { if (c === f) continue; return c; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (1 === o) throw o = 4, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = 3; var h = s(r, e, n); if ("normal" === h.type) { if (o = n.done ? 4 : 2, h.arg === f) continue; return { value: h.arg, done: n.done }; } "throw" === h.type && (o = 4, n.method = "throw", n.arg = h.arg); } }; }(r, n, new Context(o || [])), !0), a; } function s(t, r, e) { try { return { type: "normal", arg: t.call(r, e) }; } catch (t) { return { type: "throw", arg: t }; } } r.wrap = h; var f = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var l = {}; c(l, i, function () { return this; }); var p = Object.getPrototypeOf, y = p && p(p(x([]))); y && y !== e && n.call(y, i) && (l = y); var v = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(l); function g(t) { ["next", "throw", "return"].forEach(function (r) { c(t, r, function (t) { return this._invoke(r, t); }); }); } function AsyncIterator(t, r) { function e(o, i, a, u) { var c = s(t[o], t, i); if ("throw" !== c.type) { var h = c.arg, f = h.value; return f && "object" == _typeof(f) && n.call(f, "__await") ? r.resolve(f.__await).then(function (t) { e("next", t, a, u); }, function (t) { e("throw", t, a, u); }) : r.resolve(f).then(function (t) { h.value = t, a(h); }, function (t) { return e("throw", t, a, u); }); } u(c.arg); } var o; c(this, "_invoke", function (t, n) { function i() { return new r(function (r, o) { e(t, n, r, o); }); } return o = o ? o.then(i, i) : i(); }, !0); } function d(r, e) { var n = e.method, o = r.i[n]; if (o === t) return e.delegate = null, "throw" === n && r.i.return && (e.method = "return", e.arg = t, d(r, e), "throw" === e.method) || "return" !== n && (e.method = "throw", e.arg = new TypeError("The iterator does not provide a '" + n + "' method")), f; var i = s(o, r.i, e.arg); if ("throw" === i.type) return e.method = "throw", e.arg = i.arg, e.delegate = null, f; var a = i.arg; return a ? a.done ? (e[r.r] = a.value, e.next = r.n, "return" !== e.method && (e.method = "next", e.arg = t), e.delegate = null, f) : a : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, f); } function w(t) { this.tryEntries.push(t); } function m(r) { var e = r[4] || {}; e.type = "normal", e.arg = t, r[4] = e; } function Context(t) { this.tryEntries = [[-1]], t.forEach(w, this), this.reset(!0); } function x(r) { if (null != r) { var e = r[i]; if (e) return e.call(r); if ("function" == typeof r.next) return r; if (!isNaN(r.length)) { var o = -1, a = function e() { for (; ++o < r.length;) if (n.call(r, o)) return e.value = r[o], e.done = !1, e; return e.value = t, e.done = !0, e; }; return a.next = a; } } throw new TypeError(_typeof(r) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, c(v, "constructor", GeneratorFunctionPrototype), c(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = c(GeneratorFunctionPrototype, u, "GeneratorFunction"), r.isGeneratorFunction = function (t) { var r = "function" == typeof t && t.constructor; return !!r && (r === GeneratorFunction || "GeneratorFunction" === (r.displayName || r.name)); }, r.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, c(t, u, "GeneratorFunction")), t.prototype = Object.create(v), t; }, r.awrap = function (t) { return { __await: t }; }, g(AsyncIterator.prototype), c(AsyncIterator.prototype, a, function () { return this; }), r.AsyncIterator = AsyncIterator, r.async = function (t, e, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(h(t, e, n, o), i); return r.isGeneratorFunction(e) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, g(v), c(v, u, "Generator"), c(v, i, function () { return this; }), c(v, "toString", function () { return "[object Generator]"; }), r.keys = function (t) { var r = Object(t), e = []; for (var n in r) e.unshift(n); return function t() { for (; e.length;) if ((n = e.pop()) in r) return t.value = n, t.done = !1, t; return t.done = !0, t; }; }, r.values = x, Context.prototype = { constructor: Context, reset: function reset(r) { if (this.prev = this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(m), !r) for (var e in this) "t" === e.charAt(0) && n.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0][4]; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(r) { if (this.done) throw r; var e = this; function n(t) { a.type = "throw", a.arg = r, e.next = t; } for (var o = e.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i[4], u = this.prev, c = i[1], h = i[2]; if (-1 === i[0]) return n("end"), !1; if (!c && !h) throw Error("try statement without catch or finally"); if (null != i[0] && i[0] <= u) { if (u < c) return this.method = "next", this.arg = t, n(c), !0; if (u < h) return n(h), !1; } } }, abrupt: function abrupt(t, r) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var n = this.tryEntries[e]; if (n[0] > -1 && n[0] <= this.prev && this.prev < n[2]) { var o = n; break; } } o && ("break" === t || "continue" === t) && o[0] <= r && r <= o[2] && (o = null); var i = o ? o[4] : {}; return i.type = t, i.arg = r, o ? (this.method = "next", this.next = o[2], f) : this.complete(i); }, complete: function complete(t, r) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && r && (this.next = r), f; }, finish: function finish(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[2] === t) return this.complete(e[4], e[3]), m(e), f; } }, catch: function _catch(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[0] === t) { var n = e[4]; if ("throw" === n.type) { var o = n.arg; m(e); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(r, e, n) { return this.delegate = { i: x(r), r: e, n: n }, "next" === this.method && (this.arg = t), f; } }, r; }
var _marked = /*#__PURE__*/_regeneratorRuntime().mark(getCollectionsSaga),
  _marked2 = /*#__PURE__*/_regeneratorRuntime().mark(fetchAllCollectionsByTypesSaga),
  _marked3 = /*#__PURE__*/_regeneratorRuntime().mark(getAllCollectionsTypesSaga),
  _marked4 = /*#__PURE__*/_regeneratorRuntime().mark(addHotelToCollectionSaga),
  _marked5 = /*#__PURE__*/_regeneratorRuntime().mark(addCollectionSaga),
  _marked6 = /*#__PURE__*/_regeneratorRuntime().mark(removeCollectionSaga),
  _marked7 = /*#__PURE__*/_regeneratorRuntime().mark(removeHotelSaga),
  _marked8 = /*#__PURE__*/_regeneratorRuntime().mark(updateCollectionSaga),
  _marked9 = /*#__PURE__*/_regeneratorRuntime().mark(collectionsRootSaga);
var COLLECTIONS_HOST = 'https://collections.otpusk.com';
var SUCCESS_STATUS = 200;
function getCollectionsSaga(token) {
  var api, lang, response, collections;
  return _regeneratorRuntime().wrap(function getCollectionsSaga$(_context) {
    while (1) switch (_context.prev = _context.next) {
      case 0:
        _context.next = 2;
        return (0, _effects.select)(_selectors2.getAPIToken);
      case 2:
        api = _context.sent;
        _context.next = 5;
        return (0, _effects.select)(_selectors.getLang);
      case 5:
        lang = _context.sent;
        _context.prev = 6;
        _context.next = 9;
        return (0, _effects.call)(fetch, "".concat(COLLECTIONS_HOST, "/api/collections?locale=").concat((0, _localization.convertLangToLocale)(lang)), {
          headers: {
            'X-API-KEY': api,
            'X-USER-ID': token
          }
        });
      case 9:
        response = _context.sent;
        _context.next = 12;
        return (0, _effects.call)([response, 'json']);
      case 12:
        collections = _context.sent;
        return _context.abrupt("return", {
          key: token,
          collections: R.map(_helpers.normalizeCollection, collections)
        });
      case 16:
        _context.prev = 16;
        _context.t0 = _context["catch"](6);
        console.log(_context.t0);
      case 19:
      case "end":
        return _context.stop();
    }
  }, _marked, null, [[6, 16]]);
}
function fetchAllCollectionsByTypesSaga() {
  var project, tf, user, collectionsByTokens, allCollections;
  return _regeneratorRuntime().wrap(function fetchAllCollectionsByTypesSaga$(_context2) {
    while (1) switch (_context2.prev = _context2.next) {
      case 0:
        _context2.next = 2;
        return (0, _effects.select)(_selectors2.getProjectToken);
      case 2:
        project = _context2.sent;
        _context2.next = 5;
        return (0, _effects.select)(_selectors2.getTFToken);
      case 5:
        tf = _context2.sent;
        _context2.next = 8;
        return (0, _effects.select)(_selectors2.getUserToken);
      case 8:
        user = _context2.sent;
        _context2.next = 11;
        return (0, _effects.all)(R.map(function (token) {
          return (0, _effects.call)(getCollectionsSaga, token);
        }, [project, tf, user]));
      case 11:
        collectionsByTokens = _context2.sent;
        allCollections = R.reduce(function (results, _ref) {
          var key = _ref.key,
            collections = _ref.collections;
          return R.set(R.lensProp(key), collections, results);
        }, {}, collectionsByTokens);
        return _context2.abrupt("return", allCollections);
      case 14:
      case "end":
        return _context2.stop();
    }
  }, _marked2);
}
function getAllCollectionsTypesSaga() {
  var allCollections;
  return _regeneratorRuntime().wrap(function getAllCollectionsTypesSaga$(_context3) {
    while (1) switch (_context3.prev = _context3.next) {
      case 0:
        if (!true) {
          _context3.next = 14;
          break;
        }
        _context3.next = 3;
        return (0, _effects.take)(_actions2.getCollections);
      case 3:
        _context3.next = 5;
        return (0, _effects.put)((0, _actions.register)(_constants.FETCH_COLLECTIONS_UI_KEY, {
          loading: true
        }));
      case 5:
        _context3.next = 7;
        return (0, _effects.call)(fetchAllCollectionsByTypesSaga);
      case 7:
        allCollections = _context3.sent;
        _context3.next = 10;
        return (0, _effects.put)((0, _actions2.setCollections)(allCollections));
      case 10:
        _context3.next = 12;
        return (0, _effects.put)((0, _actions.update)(_constants.FETCH_COLLECTIONS_UI_KEY, {
          loading: false,
          completed: true
        }));
      case 12:
        _context3.next = 0;
        break;
      case 14:
      case "end":
        return _context3.stop();
    }
  }, _marked3);
}
function addHotelToCollectionSaga() {
  var _loop;
  return _regeneratorRuntime().wrap(function addHotelToCollectionSaga$(_context5) {
    while (1) switch (_context5.prev = _context5.next) {
      case 0:
        _loop = /*#__PURE__*/_regeneratorRuntime().mark(function _loop() {
          var _yield$take, _yield$take$payload, hotelID, collectionID, api, token, response, errorMsg;
          return _regeneratorRuntime().wrap(function _loop$(_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return (0, _effects.take)(_actions2.addHotelToCollection);
              case 2:
                _yield$take = _context4.sent;
                _yield$take$payload = _yield$take.payload;
                hotelID = _yield$take$payload.hotelID;
                collectionID = _yield$take$payload.collectionID;
                _context4.next = 8;
                return (0, _effects.put)((0, _actions.register)(_constants.ADD_HOTEL_TO_COLLECTION_UI_KEY, {
                  loading: true
                }));
              case 8:
                _context4.next = 10;
                return (0, _effects.select)(_selectors2.getAPIToken);
              case 10:
                api = _context4.sent;
                _context4.next = 13;
                return (0, _effects.select)(function (state) {
                  return (0, _selectors2.getTokenByCollection)(state, {
                    collectionID: collectionID
                  });
                });
              case 13:
                token = _context4.sent;
                _context4.prev = 14;
                _context4.next = 17;
                return (0, _effects.call)(fetch, "".concat(COLLECTIONS_HOST, "/api/collections/").concat(collectionID, "/hotel"), {
                  method: 'POST',
                  headers: {
                    'X-API-KEY': api,
                    'X-USER-ID': token,
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify({
                    hotel: hotelID
                  })
                });
              case 17:
                response = _context4.sent;
                if (!(response.status === SUCCESS_STATUS)) {
                  _context4.next = 23;
                  break;
                }
                _context4.next = 21;
                return (0, _effects.put)((0, _actions.update)(_constants.ADD_HOTEL_TO_COLLECTION_UI_KEY, {
                  success: true
                }));
              case 21:
                _context4.next = 24;
                break;
              case 23:
                throw response;
              case 24:
                _context4.next = 33;
                break;
              case 26:
                _context4.prev = 26;
                _context4.t0 = _context4["catch"](14);
                _context4.next = 30;
                return (0, _effects.call)(_api.getErrorMessage, _context4.t0);
              case 30:
                errorMsg = _context4.sent;
                _context4.next = 33;
                return (0, _effects.put)((0, _actions.update)(_constants.ADD_HOTEL_TO_COLLECTION_UI_KEY, {
                  error: true,
                  message: errorMsg
                }));
              case 33:
                _context4.prev = 33;
                _context4.next = 36;
                return (0, _effects.put)((0, _actions.update)(_constants.ADD_HOTEL_TO_COLLECTION_UI_KEY, {
                  loading: false,
                  completed: true
                }));
              case 36:
                return _context4.finish(33);
              case 37:
              case "end":
                return _context4.stop();
            }
          }, _loop, null, [[14, 26, 33, 37]]);
        });
      case 1:
        if (!true) {
          _context5.next = 5;
          break;
        }
        return _context5.delegateYield(_loop(), "t0", 3);
      case 3:
        _context5.next = 1;
        break;
      case 5:
      case "end":
        return _context5.stop();
    }
  }, _marked4);
}
function addCollectionSaga() {
  var _yield$take2, _yield$take2$payload, name, isAgent, countryID, onSuccess, api, token, response, collection, errorMsg;
  return _regeneratorRuntime().wrap(function addCollectionSaga$(_context6) {
    while (1) switch (_context6.prev = _context6.next) {
      case 0:
        if (!true) {
          _context6.next = 46;
          break;
        }
        _context6.next = 3;
        return (0, _effects.take)(_actions2.createCollection);
      case 3:
        _yield$take2 = _context6.sent;
        _yield$take2$payload = _yield$take2.payload;
        name = _yield$take2$payload.name;
        isAgent = _yield$take2$payload.isAgent;
        countryID = _yield$take2$payload.countryID;
        onSuccess = _yield$take2$payload.onSuccess;
        _context6.next = 11;
        return (0, _effects.select)(_selectors2.getAPIToken);
      case 11:
        api = _context6.sent;
        _context6.next = 14;
        return (0, _effects.select)(isAgent ? _selectors2.getTFToken : _selectors2.getUserToken);
      case 14:
        token = _context6.sent;
        _context6.next = 17;
        return (0, _effects.put)((0, _actions.register)(_constants.CREATE_COLLECTION_UI_KEY, {
          loading: true
        }));
      case 17:
        _context6.prev = 17;
        _context6.next = 20;
        return (0, _effects.call)(fetch, "".concat(COLLECTIONS_HOST, "/api/collections"), {
          method: 'POST',
          headers: {
            'X-API-KEY': api,
            'X-USER-ID': token,
            'Content-Type': 'application/json'
          },
          body: R.call(R.pipe(R.when(function (_ref2) {
            var country = _ref2.country;
            return !country;
          }, R.omit(['country'])), JSON.stringify), {
            name: name,
            country: countryID
          })
        });
      case 20:
        response = _context6.sent;
        if (!(response.status === SUCCESS_STATUS)) {
          _context6.next = 30;
          break;
        }
        _context6.next = 24;
        return (0, _effects.call)([response, 'json']);
      case 24:
        collection = _context6.sent;
        _context6.next = 27;
        return (0, _effects.put)((0, _actions2.addCollection)(token, collection));
      case 27:
        onSuccess(collection);
        _context6.next = 31;
        break;
      case 30:
        throw response;
      case 31:
        _context6.next = 40;
        break;
      case 33:
        _context6.prev = 33;
        _context6.t0 = _context6["catch"](17);
        _context6.next = 37;
        return (0, _effects.call)(_api.getErrorMessage, _context6.t0);
      case 37:
        errorMsg = _context6.sent;
        _context6.next = 40;
        return (0, _effects.put)((0, _actions.update)(_constants.CREATE_COLLECTION_UI_KEY, {
          error: true,
          message: errorMsg
        }));
      case 40:
        _context6.prev = 40;
        _context6.next = 43;
        return (0, _effects.put)((0, _actions.update)(_constants.CREATE_COLLECTION_UI_KEY, {
          loading: false,
          completed: true
        }));
      case 43:
        return _context6.finish(40);
      case 44:
        _context6.next = 0;
        break;
      case 46:
      case "end":
        return _context6.stop();
    }
  }, _marked5, null, [[17, 33, 40, 44]]);
}
function removeCollectionSaga() {
  var _loop2;
  return _regeneratorRuntime().wrap(function removeCollectionSaga$(_context8) {
    while (1) switch (_context8.prev = _context8.next) {
      case 0:
        _loop2 = /*#__PURE__*/_regeneratorRuntime().mark(function _loop2() {
          var _yield$take3, collectionID, api, token, uiKey;
          return _regeneratorRuntime().wrap(function _loop2$(_context7) {
            while (1) switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return (0, _effects.take)(_actions2.startdeleteCollection);
              case 2:
                _yield$take3 = _context7.sent;
                collectionID = _yield$take3.payload;
                _context7.next = 6;
                return (0, _effects.select)(_selectors2.getAPIToken);
              case 6:
                api = _context7.sent;
                _context7.next = 9;
                return (0, _effects.select)(function (state) {
                  return (0, _selectors2.getTokenByCollection)(state, {
                    collectionID: collectionID
                  });
                });
              case 9:
                token = _context7.sent;
                uiKey = (0, _helpers.createDeleteCollectionUIKey)(collectionID);
                _context7.next = 13;
                return (0, _effects.put)((0, _actions.register)(uiKey, {
                  loading: true
                }));
              case 13:
                _context7.next = 15;
                return (0, _effects.call)(fetch, "".concat(COLLECTIONS_HOST, "/api/collections/").concat(collectionID), {
                  method: 'DELETE',
                  headers: {
                    'X-API-KEY': api,
                    'X-USER-ID': token
                  }
                });
              case 15:
                _context7.next = 17;
                return (0, _effects.put)((0, _actions2.deleteCollection)(token, collectionID));
              case 17:
                _context7.next = 19;
                return (0, _effects.put)((0, _actions.update)(uiKey, {
                  loading: false,
                  completed: true
                }));
              case 19:
              case "end":
                return _context7.stop();
            }
          }, _loop2);
        });
      case 1:
        if (!true) {
          _context8.next = 5;
          break;
        }
        return _context8.delegateYield(_loop2(), "t0", 3);
      case 3:
        _context8.next = 1;
        break;
      case 5:
      case "end":
        return _context8.stop();
    }
  }, _marked6);
}
function removeHotelSaga() {
  var _loop3;
  return _regeneratorRuntime().wrap(function removeHotelSaga$(_context0) {
    while (1) switch (_context0.prev = _context0.next) {
      case 0:
        _loop3 = /*#__PURE__*/_regeneratorRuntime().mark(function _loop3() {
          var _yield$take4, _yield$take4$payload, collectionID, hotelID, api, token, uiKey;
          return _regeneratorRuntime().wrap(function _loop3$(_context9) {
            while (1) switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return (0, _effects.take)(_actions2.startDeleteHotel);
              case 2:
                _yield$take4 = _context9.sent;
                _yield$take4$payload = _yield$take4.payload;
                collectionID = _yield$take4$payload.collectionID;
                hotelID = _yield$take4$payload.hotelID;
                _context9.next = 8;
                return (0, _effects.select)(_selectors2.getAPIToken);
              case 8:
                api = _context9.sent;
                _context9.next = 11;
                return (0, _effects.select)(function (state) {
                  return (0, _selectors2.getTokenByCollection)(state, {
                    collectionID: collectionID
                  });
                });
              case 11:
                token = _context9.sent;
                uiKey = (0, _helpers.createDeleteHotelUIKey)(hotelID);
                _context9.next = 15;
                return (0, _effects.put)((0, _actions.register)(uiKey, {
                  loading: true
                }));
              case 15:
                _context9.next = 17;
                return (0, _effects.call)(fetch, "".concat(COLLECTIONS_HOST, "/api/collections/").concat(collectionID, "/hotel"), {
                  method: 'DELETE',
                  headers: {
                    'X-API-KEY': api,
                    'X-USER-ID': token,
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify({
                    hotel: hotelID
                  })
                });
              case 17:
                _context9.next = 19;
                return (0, _effects.put)((0, _actions2.deleteHotel)(token, collectionID, hotelID));
              case 19:
                _context9.next = 21;
                return (0, _effects.put)((0, _actions.update)(uiKey, {
                  loading: false,
                  completed: true
                }));
              case 21:
              case "end":
                return _context9.stop();
            }
          }, _loop3);
        });
      case 1:
        if (!true) {
          _context0.next = 5;
          break;
        }
        return _context0.delegateYield(_loop3(), "t0", 3);
      case 3:
        _context0.next = 1;
        break;
      case 5:
      case "end":
        return _context0.stop();
    }
  }, _marked7);
}
function updateCollectionSaga() {
  var _loop4;
  return _regeneratorRuntime().wrap(function updateCollectionSaga$(_context10) {
    while (1) switch (_context10.prev = _context10.next) {
      case 0:
        _loop4 = /*#__PURE__*/_regeneratorRuntime().mark(function _loop4() {
          var _yield$take5, payload, collectionID, collection, onSuccess, api, token, lang, uiKey, response, nextCollection;
          return _regeneratorRuntime().wrap(function _loop4$(_context1) {
            while (1) switch (_context1.prev = _context1.next) {
              case 0:
                _context1.next = 2;
                return (0, _effects.take)(_actions2.startUpdateCollection);
              case 2:
                _yield$take5 = _context1.sent;
                payload = _yield$take5.payload;
                collectionID = payload.collectionID, collection = payload.collection, onSuccess = payload.onSuccess;
                _context1.next = 7;
                return (0, _effects.select)(_selectors2.getAPIToken);
              case 7:
                api = _context1.sent;
                _context1.next = 10;
                return (0, _effects.select)(function (state) {
                  return (0, _selectors2.getTokenByCollection)(state, {
                    collectionID: collectionID
                  });
                });
              case 10:
                token = _context1.sent;
                _context1.next = 13;
                return (0, _effects.select)(_selectors.getLang);
              case 13:
                lang = _context1.sent;
                uiKey = (0, _helpers.createUpdateCollectionUIKey)(collectionID);
                _context1.next = 17;
                return (0, _effects.put)((0, _actions.register)(uiKey, {
                  loading: true
                }));
              case 17:
                _context1.next = 19;
                return (0, _effects.call)(fetch, "".concat(COLLECTIONS_HOST, "/api/collections/").concat(collectionID, "?locale=").concat((0, _localization.convertLangToLocale)(lang)), {
                  method: 'PUT',
                  headers: {
                    'X-API-KEY': api,
                    'X-USER-ID': token,
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify(collection)
                });
              case 19:
                response = _context1.sent;
                _context1.next = 22;
                return (0, _effects.call)([response, 'json']);
              case 22:
                nextCollection = _context1.sent;
                _context1.next = 25;
                return (0, _effects.put)((0, _actions2.updateCollection)(token, collectionID, (0, _helpers.normalizeCollection)(nextCollection)));
              case 25:
                _context1.next = 27;
                return (0, _effects.put)((0, _actions.update)(uiKey, {
                  loading: false,
                  completed: true
                }));
              case 27:
                if (onSuccess) {
                  onSuccess();
                }
              case 28:
              case "end":
                return _context1.stop();
            }
          }, _loop4);
        });
      case 1:
        if (!true) {
          _context10.next = 5;
          break;
        }
        return _context10.delegateYield(_loop4(), "t0", 3);
      case 3:
        _context10.next = 1;
        break;
      case 5:
      case "end":
        return _context10.stop();
    }
  }, _marked8);
}
function collectionsRootSaga() {
  return _regeneratorRuntime().wrap(function collectionsRootSaga$(_context11) {
    while (1) switch (_context11.prev = _context11.next) {
      case 0:
        _context11.next = 2;
        return (0, _effects.all)([getAllCollectionsTypesSaga(), addHotelToCollectionSaga(), addCollectionSaga(), removeCollectionSaga(), removeHotelSaga(), updateCollectionSaga()]);
      case 2:
      case "end":
        return _context11.stop();
    }
  }, _marked9);
}